import { Component, Injector, Input, OnInit } from '@angular/core';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

/**
 * Direct Cap Miscellaneous Revenue Widget
 */
@Component({
  selector: 'misc-revenue-widget',
  templateUrl: './misc-revenue-widget.component.html',
  styleUrls: ['./misc-revenue-widget.component.scss', '../../common/css/general.scss']
})
export class MiscRevenueWidgetComponent extends WidgetDynamicBaseComponent implements OnInit{

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'miscRevenue', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {    
    this.useDefaultServiceSaveChangesHandler("miscRevenue", this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('miscRevenue');

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('miscRevenue', this.getReport());
  }


  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  preprocessLoadedData(data) {
    this.setDirtyFlag(false);
    return data;
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData?.rows?.length + 3;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    return false;
  }
}

